module.exports = __webpack_public_path__ + "img/demand.e2a25fa.png";